// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"7":"33c2d715","117":"66e33d65","260":"8ed3335e","347":"91db5074","453":"9bbd3bb1","594":"4041de44","596":"c7e21c26","624":"d1f1cd60","725":"1e6740f5","741":"d17129c9","865":"7436837e","898":"c48285a5"}[chunkId] + ".chunk.js";
};